export function debounce(fn: Function, delay: number) {
  let timeoutID: ReturnType<typeof setTimeout> | undefined;
  return function (...args: any[]) {
    clearTimeout(timeoutID);
    timeoutID = setTimeout(() => {
      fn.apply(this, [...args, timeoutID]);
    }, delay);
    return timeoutID;
  };
}
